import React from 'react';
import PropTypes from 'prop-types';
import { findIndex, map, includes } from 'lodash';
import ReactCollapse from 'react-collapse';

import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';
import Models from 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/Models.jsx';
import BrandList from 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/BrandList.jsx';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/ListingFiltersBrand.scss';

class ListingFiltersBrand extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            makeIsOpen: false,
            modelIsOpen: false,
            makes: this.mapMakes(props.makes),
        };

        this.onlyOnce = true;
        this.handleMakeChange = this.handleMakeChange.bind(this);
        this.renderMakes = this.renderMakes.bind(this);
        this.renderModels = this.renderModels.bind(this);
        this.toggleMakeCollapsable = this.toggleMakeCollapsable.bind(this);
        this.toggleModelCollapsable = this.toggleModelCollapsable.bind(this);
        this.updateVehicleMakeCriteria = this.updateVehicleMakeCriteria.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState(
            {
                makes: this.mapMakes(newProps.makes),
            },
            () => {
                if (this.onlyOnce && newProps.makes.length > 0) {
                    if (newProps.makes.length === 1) {
                        this.toggleModelCollapsable();
                    }
                    this.onlyOnce = false;
                }
            }
        );
    }

    mapMakes(makes) {
        // contextMake exists if URL is /en/used-inventory/mazda
        const queryParamMakes =
            (UrlService.containsPath(this.props.contextMake?.name) && this.props.contextMake?.id?.toString()) ||
            UrlService.getUrlParameter('makeIds');
        let selectedMakes;
        if (queryParamMakes) {
            selectedMakes = queryParamMakes.split(',').map((make) => parseInt(make, 10));
        } else {
            selectedMakes = map(makes, (make) => {
                if (make.get('isSelected') === true) {
                    return make.get('code');
                }
                return '';
            });
        }

        return map(makes, (make) => {
            return make.set('isSelected', includes(selectedMakes, make.code));
        });
    }

    handleMakeChange(code) {
        const { makes } = this.state;
        const index = findIndex(makes, { code: parseInt(code, 10) });

        makes[index] = makes[index].set('isSelected', !makes[index].isSelected);

        const isCheckOrUncheck = makes[index].get('isSelected');
        if (isCheckOrUncheck) AnalyticsService.ga4Trigger(TAGS.MAKES(makes[index].label));

        this.setState(
            {
                makes,
                modelIsOpen: isCheckOrUncheck,
            },
            () => {
                this.updateVehicleMakeCriteria(isCheckOrUncheck);
            }
        );
    }

    updateVehicleMakeCriteria(isCheckOrUncheck) {
        if (!isCheckOrUncheck) {
            this.props.updateVehicleCriteria([], 'modelIds');
        }
        this.mapMakes(this.state.makes);
        this.props.updateVehicleCriteria(this.state.makes, 'makeIds', isCheckOrUncheck);
    }

    toggleMakeCollapsable() {
        this.setState((prevState) => {
            return { makeIsOpen: !prevState.makeIsOpen };
        });
    }

    toggleModelCollapsable() {
        this.setState((prevState) => {
            return { modelIsOpen: !prevState.modelIsOpen };
        });
    }

    renderMakes() {
        const { makes } = this.state;

        return makes.map((make) => (
            <BrandList key={make.code} make={make} handleMakeSelection={this.handleMakeChange} />
        ));
    }

    renderModels(currentMake) {
        const { vehicleCriteria } = this.props;
        return (
            currentMake.length > 0 && (
                <Models
                    models={this.props.models}
                    isMakeSelected
                    updateVehicleCriteria={(metadatas, attribute) => {
                        this.props.updateVehicleCriteria(metadatas, attribute);
                    }}
                    selectedModels={vehicleCriteria.modelIds}
                    noMakeListStr={this.props.noMakeListStr}
                    modelListStr={this.props.modelListStr}
                    make={currentMake[0]}
                />
            )
        );
    }

    render() {
        const { makes } = this.state;
        const brandList = this.renderMakes();

        const makeClass = this.state.makeIsOpen
            ? 'listing-used-filters-bloc listing-used-filters-brand isOpen'
            : 'listing-used-filters-bloc listing-used-filters-brand';

        const makeList = makes.length > 1 && (
            <div className={makeClass}>
                <button className="listing-used-filters-title is-bold" onClick={this.toggleMakeCollapsable}>
                    {LocaleService.t('FILTERS.MAKES')}
                    <icon className="icon-Arrow-Menu-Top" />
                </button>
                <ReactCollapse isOpened={this.state.makeIsOpen}>
                    <div className="listing-used-brands-container">{brandList}</div>
                </ReactCollapse>
            </div>
        );

        const currentMake = makes.filter((make) => make.isSelected);

        let modelList = this.renderModels(currentMake);
        if (currentMake && currentMake !== null && currentMake.length > 0) {
            modelList = this.renderModels(currentMake);
        } else if (makes.length === 1) {
            modelList = this.renderModels(makes);
        }

        const modelClass = ['listing-used-filters-bloc', 'listing-used-filters-model'];
        let collapseModel = true;

        if ((currentMake && currentMake !== null && currentMake.length > 0) || makes.length === 1) {
            modelClass.push('isAvailable');
            collapseModel = this.state.modelIsOpen;
            if (this.state.modelIsOpen) {
                modelClass.push('isOpen');
            }
        }

        return (
            <div className="listing-used-filters-bloc-make">
                {makeList}
                <div className={modelClass.join(' ')}>
                    <button className="listing-used-filters-title is-bold" onClick={this.toggleModelCollapsable}>
                        {LocaleService.t('FILTERS.MODELS')}
                        <icon className="icon-Arrow-Menu-Top" />
                    </button>
                    <ReactCollapse isOpened={collapseModel}>{modelList}</ReactCollapse>
                </div>
            </div>
        );
    }
}

ListingFiltersBrand.defaultProps = {
    makes: [],
    contextMake: undefined,
    noMakeListStr: '',
    modelListStr: '',
};

ListingFiltersBrand.propTypes = {
    makes: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    contextMake: PropTypes.oneOf([PropTypes.object, PropTypes.undefined]),
    updateVehicleCriteria: PropTypes.func.isRequired,
    vehicleCriteria: PropTypes.instanceOf(VehicleCriteriaModel).isRequired,
    noMakeListStr: PropTypes.string,
    modelListStr: PropTypes.string,
};

ListingFiltersBrand.displayName = 'ListingFiltersBrand';

export default ListingFiltersBrand;
